'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'mug-hot';
var width = 512;
var height = 512;
var aliases = [9749];
var unicode = 'f7b6';
var svgPathData = 'M80 8c0-4.4-3.6-8-8-8s-8 3.6-8 8c0 27.3 5.1 45.2 13.6 57.9C86 78.4 97.1 85 106.7 90.6l.4 .3c9.9 5.9 18.2 10.9 24.4 20.1c6.2 9.2 10.9 23.5 10.9 49c0 4.4 3.6 8 8 8s8-3.6 8-8c0-27.3-5.1-45.2-13.6-57.9c-8.4-12.5-19.5-19.1-29.1-24.7l-.4-.3C105.4 71.2 97.1 66.2 90.9 57C84.7 47.8 80 33.5 80 8zM209.6 8c0-4.4-3.6-8-8-8s-8 3.6-8 8c0 27.3 5.1 45.2 13.6 57.9c8.4 12.5 19.5 19.1 29.1 24.7l.4 .3c9.9 5.9 18.2 10.9 24.4 20.1c6.2 9.2 10.9 23.5 10.9 49c0 4.4 3.6 8 8 8s8-3.6 8-8c0-27.3-5.1-45.2-13.6-57.9C266 89.6 254.9 83 245.3 77.4l-.4-.3C235 71.2 226.7 66.2 220.5 57c-6.2-9.2-10.9-23.5-10.9-49zM344 208l24 0 0 208c0 44.2-35.8 80-80 80L96 496c-44.2 0-80-35.8-80-80l0-192c0-8.8 7.2-16 16-16l312 0zm40 176l0-176 24 0c48.6 0 88 39.4 88 88s-39.4 88-88 88l-24 0zm0 32l0-16 24 0c57.4 0 104-46.6 104-104s-46.6-104-104-104l-24 0-16 0-24 0L32 192c-17.7 0-32 14.3-32 32L0 416c0 53 43 96 96 96l192 0c53 0 96-43 96-96z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faMugHot = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;